import { render, staticRenderFns } from "./bidding-data.vue?vue&type=template&id=4cb2d187&scoped=true&"
import script from "./bidding-data.vue?vue&type=script&lang=js&"
export * from "./bidding-data.vue?vue&type=script&lang=js&"
import style0 from "./bidding-data.vue?vue&type=style&index=0&id=4cb2d187&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2d187",
  null
  
)

export default component.exports